import { Link } from 'react-router-dom';
import { PageHeader, Hero } from '../components/PageComponents';
import './Company.css';

function Company() {
  return (
    <>
      <Hero
        imageSrc="/Images/PI-ID463016.jpg"
        imageAlt="SMART-WARES"
        title="Company"
      />

      <div className="container">
        <section className="section company-content">
          <p className="company-intro">
            SMART-WARES is a Singapore-based enterprise software company delivering intelligent, reliable solutions that transform how businesses operate.
          </p>

          <article className="company-section">
            <div className="company-section-icon">👥</div>
            <h2>Our People</h2>
            <p>SMART-WARES was founded by a team of experienced software consultants with more than 10 years experience across a wide spectrum of industries.</p>
            <p>Together, we design and implement leading software products and solutions drawing on deep expertise in banking, insurance, retail, manufacturing, and the services industry.</p>
          </article>

          <hr className="section-divider" />

          <article className="company-section">
            <div className="company-section-icon">💡</div>
            <h2>How We Add Value</h2>
            <p>We simplify and deliver smart, web-based software solutions to corporations across various industries.</p>
            <p>Our products automate paper-based workflows, increase operational efficiency, and deliver timely management reporting — freeing your team to focus on higher-value activities.</p>
          </article>

          <hr className="section-divider" />

          <article className="company-section">
            <div className="company-section-icon">🤝</div>
            <h2>Your Long-Term Partner</h2>
            <p>SMART-WARES is committed to the long-term growth and prosperity of our customers. As we own the intellectual rights to all our products, we can customize our standard applications to meet the specific demands of every customer.</p>
          </article>

          <hr className="section-divider" />

          <article className="company-section contact-section">
            <h2>Contact Us</h2>
            <p>SMART-WARES is headquartered in Singapore. Submit your query using our contact form and we will respond within 2 business days.</p>

            <div className="contact-info-block">
              <strong>SMART-WARES</strong>
              <address>
                212A Tanjong Katong Road<br />
                Singapore 437005
              </address>
            </div>
            <div className="mt-lg">
              <Link to="/contact" className="button button-primary">Contact Us</Link>
            </div>
          </article>
        </section>
      </div>
    </>
  );
}

export default Company;
